import PropTypes from "prop-types";

import { Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { formatNumber } from "@/features/shared";
import { ProductVariantNameCell } from "@/features/ui";
import { ReturnableTypeEnum } from "../../returnable-type";

// Rendered inside the detail page's tab panel, so it carries no Paper or
// heading of its own.
export const ProductVariantsSection = ({
  purchaseReturnProductVariants = [],
  returnableType,
}) => {
  const showPricing =
    returnableType === ReturnableTypeEnum.PURCHASE_INVOICE ||
    returnableType === ReturnableTypeEnum.NON_INVOICE;

  const baseColumns = [
    {
      field: "name",
      headerName: "Produk Varian",
      flex: 5,
      renderCell: ({ row: { name, sku } }) => (
        <ProductVariantNameCell name={name} sku={sku} linkToStock />
      ),
    },
    {
      field: "quantity",
      headerName: "Qty",
      type: "number",
      flex: 1,
      valueFormatter: (value) => formatNumber(value),
    },
    {
      field: "unitOfMeasurement",
      headerName: "Unit",
      flex: 1,
      valueGetter: (_, row) => row.product.unitOfMeasurement.name || "-",
    },
  ];

  const pricingColumns = showPricing
    ? [
        {
          field: "price",
          headerName: "Harga",
          type: "number",
          flex: 1.5,
          valueFormatter: (value) => formatNumber(value),
        },
        {
          field: "totalPrice",
          headerName: "Total",
          flex: 2,
          type: "number",
          renderCell: ({ row }) => {
            const { discount, price, quantity } = row;
            const subtotal = (price || 0) * (quantity || 0);
            const totalPrice = subtotal - (discount || 0);
            const hasDiscount = discount && discount > 0;

            if (!hasDiscount) {
              return (
                <Typography variant="body2">
                  {formatNumber(totalPrice)}
                </Typography>
              );
            }

            return (
              <Box sx={{ py: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {formatNumber(totalPrice)}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    textDecoration: "line-through",
                    color: "text.secondary",
                    fontSize: "0.7rem",
                  }}
                >
                  {formatNumber(subtotal)}
                </Typography>
              </Box>
            );
          },
        },
      ]
    : [];

  const noteColumn = {
    field: "note",
    headerName: "Catatan",
    flex: 1.5,
    valueGetter: (_, row) => row.note || "-",
  };

  const columns = [...baseColumns, ...pricingColumns, noteColumn];

  return (
    <DataGrid
      getRowHeight={() => "auto"}
      columns={columns}
      rows={purchaseReturnProductVariants}
      disableRowSelectionOnClick
      initialState={{
        sorting: {
          sortModel: [{ field: "name", sort: "asc" }],
        },
      }}
    />
  );
};

ProductVariantsSection.propTypes = {
  purchaseReturnProductVariants: PropTypes.array,
  returnableType: PropTypes.string,
};
